import { gql } from '@apollo/client';

export const fetchOrdersForEntitlement = gql`
  query FetchOrdersForEntitlement(
    $id: String
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    entitlementDetails(id: $id) {
      id
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          orderNumber
          created
          billingGroup {
            billingGroupId
          }
          invoiceGroup {
            id
            name
            currency
            shipToParty {
              id
              name
              addressLine1
              addressLine2
              city
              country
              postcode
            }
            defaultPaymentMethod {
              id
              type
              ... on CreditCard {
                card {
                  last4Numbers
                  expirationMonth
                  expirationYear
                  brand
                }
              }
              ... on PaymentOnTerms {
                terms {
                  invoiceDueDays
                }
              }
            }
          }
          metadata {
            supportTicketNumber
          }
          metadataObj {
            supportTicketNumber
            handNote
            termsOfTransfer
            reasonCode
            newBillingAdmin
            currentBillingAdmin
            consentTaken
          }
          orderLineItems {
            nodes {
              lineItemId
              entitlementId
              parentEntitlementId
              entitlementNumber
              pricingPlanId
              status
              type
              quantity
              skipTrial
              orderLineItemsAdditionalNotes
              reasonCode
              pricingPlan {
                type
                billingFrequency
                pricingPlanType
                status
                description
              }
              offeringId
              offering {
                id
                name
              }
              promotionCodes
              promotions {
                id
                title
                status
                type
                promotionCode
                applicationReason {
                  id
                  readableName
                  customisable {
                    id {
                      type
                      anyOf {
                        readableName
                        id
                      }
                    }
                  }
                }
                benefits {
                  subBenefitType
                  value
                  iterations
                  duration
                  benefitType
                }
                promotionWindow {
                  endTime
                  startTime
                }
                isPromotionCustomisable
              }
              removedPromotions {
                id
                title
                status
                type
                promotionCode
                benefits {
                  subBenefitType
                  value
                  iterations
                  duration
                  benefitType
                }
                promotionWindow {
                  endTime
                  startTime
                }
              }
              orderTransitionType
              salesTransitionType
              orderLineItemsPurchaseMetadata {
                fieldName
                fieldValue
              }
              orderLineItemsAccountModification {
                accountModificationTransactionAccountId
                accountModificationInvoiceGroupId
              }
              nextBillingAnchorTimestamp
            }
          }
          contextSubject
          hasPendingInvoice
          billTo {
            billToAccountId
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
